import VIEWPORTS from '../plugins/viewports'
import PARTSLOADER from '../plugins/partsloader'
import CONTENT_TITLE from '../plugins/contentTitle'

// スクロールして画面エリアに入ったら要素を表示する lazydisp
import LAZYDISP from '../plugins/lazydisp'

// カレンダーカスタマイズ
// import FULLCALENDAR from '../plugins/fullcalendar'

// IE11でSVGの外部参照を有効にする
import 'svgxuse'
import IE_SRCSET from '../plugins/polyfill-ie-srcset'

export default function INIT() {
  /*****
   * Promise
   */
  window.load = {
    'header': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'footer': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'mapScript': new $.Deferred, // googlemapAPIのURLパラメータでresolveします
    'loadHtml': new $.Deferred, // すべてのLoad Htmlが完了したらresolveする
  }

  //header.html, footer.html読み込み
  PARTSLOADER([
    {
      name: 'footer',
      loadhtml: '/asset/html/footer.html',
      target: 'footer',
      method:'replaceWith',
      callback(){
        $('footer [data-plugin="getCopyright"]').getCopyright()
      }
    },
    {
      name: 'header',
      loadhtml: '/asset/html/header.html',
      target: 'header',
      method:'replaceWith',
      callback(r,_){
        $('header .p-gnav').currentMenu({mode:1,default:999});
      }
    }
  ])
  // プライバシー・会社概要・サイトマップのコンテンツタイトル
  CONTENT_TITLE({
    'sitemap':'Sitemap',
    'privacy':'Privacy Policy',
    'profile':'CORPORATE'
  })

  IE_SRCSET()

  // DOM Ready
  $(() => {
    // <body>にクラス付与
    $.bodyClass();
    // htmlデータ読み込み
    $('[data-load-html]').loadHtml();
    // カレントメニュー
    $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999});
    // ページングテキスト
    $.pagingText({
      prev:'PREV',
      next:'NEXT',
      list:'LIST'
    })
    // ページトップリンクをスクロール量で表示するサンプル
    $.scrollspy({
      trigger:200,
      onBefore(/* pos */) {
        $('.p-pagetop__wrap').addClass('hidden');
      },
      onAfter() {
        $('.p-pagetop__wrap').removeClass('hidden');
      }
    })

    // lazydisp
    $.when( window.load['loadHtml'] ).then( () => LAZYDISP('[data-lazydisp]') )
  
    const parallax = () => {
      let $boxes = $('[data-plugin="parallax"]')
      $boxes.each( (i,obj) => {
        gsap.fromTo( obj, {
          y: '0'
        },{
          y: obj.dataset.duration || '10vh',
          // yPercent: 100 * parseFloat( obj.dataset.speed || 1 ),
          // xPercent: -100 * parseFloat( obj.dataset.speed || 1 ),
          scrollTrigger: {
            trigger: obj,
            start: `top ${obj.dataset.startAt || 'top'}`, // the default values
            end: `+=${window.innerHeight}px`,
            scrub: true, // アニメーションをスクロール位置にリンクさせる
            markers: (obj.dataset.marker == 'true'), // マーカー表示
            onEnter: () => false,
            onEnterBack: () => false,
            onLeave: () => false,
            onLeaveBack: () => false
          }
        })
      })
    }
  })

  // window.load['contentFooter'].done(() => {
  //   // fullcalendar挿入
  //   FULLCALENDAR(document.querySelectorAll('[data-plugin="calendar"]'),{
  //     googleCalendarApiKey: 'AIzaSyAp7Q8UGPJkuCJnRnq4M9PZgilB1XTkVQM',
  //     contentHeight: 500,
  //     eventSources: [
  //       {
  //         googleCalendarId: 'japanese__ja@holiday.calendar.google.com',
  //         className: 'holiday'
  //       }
  //     ]
  //   })
  // })

}